/**
 * Route subtree mounted at `/w/:slug/workflows` from `App.tsx`. Pages are
 * code-split via `React.lazy` + `<Suspense>` so the workflows bundle (canvas +
 * code editor) doesn't bloat the initial dashboard load.
 *
 * Mirrors `agents/routes.tsx`.
 */

import { lazy, Suspense } from "react";
import { Route } from "react-router";

import { RouteFallback } from "../components/route-fallback";

const WorkflowsListPage = lazy(() =>
  import("./pages/WorkflowsListPage").then((m) => ({ default: m.WorkflowsListPage })),
);
const WorkflowEditorPage = lazy(() =>
  import("./pages/WorkflowEditorPage").then((m) => ({ default: m.WorkflowEditorPage })),
);
const WorkflowRunsPage = lazy(() =>
  import("./pages/WorkflowRunsPage").then((m) => ({ default: m.WorkflowRunsPage })),
);
const WorkflowAgentsPage = lazy(() =>
  import("./pages/WorkflowAgentsPage").then((m) => ({ default: m.WorkflowAgentsPage })),
);

function withSuspense(node: React.ReactElement): React.ReactElement {
  return <Suspense fallback={<RouteFallback />}>{node}</Suspense>;
}

/**
 * Returns the JSX route definitions to drop inside the workspace-scoped
 * `<Route path="/w/:slug">` block in `App.tsx`.
 */
export function workflowsRoutes() {
  return (
    <>
      <Route path="workflows" element={withSuspense(<WorkflowsListPage />)} />
      <Route path="workflows/runs" element={withSuspense(<WorkflowRunsPage />)} />
      <Route path="workflows/agents" element={withSuspense(<WorkflowAgentsPage />)} />
      <Route path="workflows/:workflowId" element={withSuspense(<WorkflowEditorPage />)} />
    </>
  );
}
